module.exports = __webpack_public_path__ + "images/0220f928489ec1dd15ae8516f1c0d58a.png";